/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type SalesPartnerCreateCustomerSalutationEnum =
  (typeof SalesPartnerCreateCustomerSalutationEnum)[keyof typeof SalesPartnerCreateCustomerSalutationEnum];

export const SalesPartnerCreateCustomerSalutationEnum = {
  MR: "MR",
  MS: "MS",
  MX: "MX",
} as const;
